module.exports = __webpack_public_path__ + "static/media/mp.a701ba66.svg";